const menu = {
    label: '• Agrupador',
    to: '/sol/agrupador',
    rules: ['SOL-001'],
};

export default menu;
